import "../App.css";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import GitHubIcon from "@mui/icons-material/GitHub";
import { useState, useEffect } from "react";

export default function Slidebar() {
  const [select, setSelect] = useState(0);

  const links = [
    { href: "/", text: "Home" },
    { href: "#about", text: "About Me" },
    { href: "#workExperience", text: "Work Experience" },
    { href: "#resume", text: "Skills and Certificates" },
    { href: "#projects", text: "Projects" },
    { href: "#contact", text: "Contact" },
  ];

  useEffect(() => {
    const sectionIds = links.map((link) => link.href.substring(1));

    const handleScroll = () => {
      const scrollPosition = window.scrollY;

      for (let i = 0; i < sectionIds.length; i++) {
        const section = document.getElementById(sectionIds[i]);

        if (section) {
          // Adjusted the comparison for the lower bound
          const lowerBound = section.offsetTop - 20;

          if (
            scrollPosition >= lowerBound &&
            (i === sectionIds.length - 1 ||
              scrollPosition <
                document.getElementById(sectionIds[i + 1]).offsetTop)
          ) {
            setSelect(i);
            break;
          }
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  });

  return (
    <div className='flex-none  bg-black h-screen min-w-[25%] fixed '>
      <div className='nav flex  text-white text-lg mt-10 flex-col align-middle justify-center text-center w-full gap-5 overflow-hidden'>
        <div data-aos='slide-down'>
          <img
            src={require("../assets/images/profile_pic2.jfif")}
            alt='Brendon Tan'
            className='rounded-full border-solid cursor-pointer  border-[8px] border-stone-600 min-h-fit mx-auto  max-w-[190px]'
          />
          <h3 className='text-white name py-4 font-medium '>Brendon Tan</h3>
        </div>
        {links.map((link, index) => (
          <p
            key={index}
            onClick={() => setSelect(index)}
            className={`cursor-pointer hover:text-blue-600 hover:-translate-y-0.5 hover:text-xl transition hover:transition ${
              select === index ? "text-blue-600 " : ""
            }`}
          >
            <a href={link.href}>{link.text}</a>
          </p>
        ))}
      </div>
      <div
        className='text-white flex flex-row gap-5 w-fit mx-auto pt-7'
        data-aos='slide-up'
        data-aos-delay='2300'
      >
        <div
          onClick={() =>
            window.open("https://github.com/brendontan03", "_blank")
          }
        >
          <GitHubIcon className='cursor-pointer hover:scale-105' />
        </div>
        <div
          onClick={() =>
            window.open(
              "https://www.linkedin.com/in/brendon-tan-544397264/",
              "_blank"
            )
          }
        >
          {" "}
          <LinkedInIcon className='cursor-pointer hover:scale-105' />
        </div>
      </div>
    </div>
  );
}
